export { JiraServiceManagementIcon } from './icon';
export { JiraServiceManagementLogo } from './logo';
